import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-in-progress-page',
  standalone: true,
  imports: [
    RouterLink,
    CommonModule,
    TranslateModule
  ],
  templateUrl: './in-progress-page.html',
  styleUrl: './in-progress-page.css',
})
export class InProgressPage {}
